import React from 'react';
import styled, { css, keyframes } from 'styled-components';

import RefreshButton from '../assets/refresh-button.svg';

export default function RefreshListButton({ onClick, itemsCount, refreshing }) {
	return (
		<Container className='refresh-list-button' onClick={onClick}>
			<Img src={RefreshButton} alt='refresh' refreshing={refreshing} />
			<Text>{itemsCount} Items</Text>
		</Container>
	);
}

const Container = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100px;
	cursor: pointer;
`;

const Text = styled.span`
	color: var(--sub-text-color);
	font-family: 'Noto Sans Regular';
	font-size: 16px;
	padding-left: 5px;
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Img = styled.img`
	animation: ${props =>
		props.refreshing
			? css`
					${spin} 1s 0s infinite linear;
			  `
			: `none`};
`;
